import { render } from "./HeaderFooterCMS.vue?vue&type=template&id=215cf485"
import script from "../js/header-footer-cms.js?vue&type=script&lang=js"
export * from "../js/header-footer-cms.js?vue&type=script&lang=js"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/platinum-landscape/platinum-landscape-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__